import { render, staticRenderFns } from "./MountainBox.vue?vue&type=template&id=278061a9&scoped=true&functional=true&"
import script from "./MountainBox.vue?vue&type=script&lang=ts&"
export * from "./MountainBox.vue?vue&type=script&lang=ts&"
import style0 from "./MountainBox.vue?vue&type=style&index=0&id=278061a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "278061a9",
  null
  
)

export default component.exports